export default __webpack_public_path__ + "static/media/about_three.857837ac.png";